import * as amplitude from '@amplitude/analytics-browser';
import { CONSTANTS } from 'config/envVariables';
import { isProdEnv } from 'utils';

if (isProdEnv()) {
  // @ts-ignore
  amplitude.init(CONSTANTS.AMPLITUDE_API_KEY as string);
}
